import { render, staticRenderFns } from "./ReviewDomain.vue?vue&type=template&id=6f37850c&scoped=true"
import script from "./ReviewDomain.vue?vue&type=script&lang=js"
export * from "./ReviewDomain.vue?vue&type=script&lang=js"
import style0 from "./ReviewDomain.vue?vue&type=style&index=0&id=6f37850c&prod&scoped=true&lang=css"
import style1 from "./ReviewDomain.vue?vue&type=style&index=1&id=6f37850c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37850c",
  null
  
)

export default component.exports